import { render, staticRenderFns } from "./TwoTiersSponsorsWithDescription.vue?vue&type=template&id=9093decc&"
import script from "./TwoTiersSponsorsWithDescription.vue?vue&type=script&lang=ts&"
export * from "./TwoTiersSponsorsWithDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports